/**
 * Constants
 */

export const API_URL_PREFIX = '/api/';
export const API_VERSION = '1.0';
export const ENTRY_POINT = 'WEB';

export const SUPPORTED_LANGUAGES: string[] = ['en-US', 'de-DE', 'es-ES', 'fr-FR', 'zh-CN'];
export const DEFAULT_LANGUAGE = 'en-US';

export const IDLE_MAX_MIN = 30 * 60 * 1000;


